// =============================================================================
// GENERATED by scripts/build-shared.cjs from functions/src/shared/crewPairing.js
// DO NOT EDIT — edit the canonical file and re-run `node scripts/build-shared.cjs`.
// (TASK-9763: dispatch pairs crew to trucks per day; clock-in preselects YOUR truck.)
//
// Side-effect module: attaches `window.CrewPairing`. jobboard.js, clock.js and
// dispatch.js read it at CALL time.
//
// The body below is the canonical file's PORTABLE CORE, copied byte for byte.
// =============================================================================
(function () {
  'use strict';

  var CREW_PAIR_KINDS = [
    ['truckIds', 'trucks'],
    ['trailerIds', 'trailers'],
    ['assetIds', 'assets']
  ];

  function _cpStr(v) {
    return v === null || v === undefined ? '' : String(v).trim();
  }

  function _cpIsObj(v) {
    return !!v && typeof v === 'object' && !Array.isArray(v);
  }

  function _cpList(v) {
    if (!Array.isArray(v)) return [];
    var out = [];
    for (var i = 0; i < v.length; i++) {
      var s = _cpStr(v[i]);
      if (s && out.indexOf(s) < 0) out.push(s);
    }
    return out;
  }

  function _cpKeyer(fn) {
    return function (ref) {
      var s = _cpStr(ref);
      if (!s) return '';
      if (typeof fn !== 'function') return s;
      var k;
      try { k = fn(s); } catch (e) { k = s; }
      return _cpStr(k) || s;
    };
  }

  // The live pairing on a day, after the read-time filter.
  // Returns { active, byPerson: { personKey: [unitKey] }, paired: [unitKey] }.
  // active === false means "behave exactly as if there were no map".
  function crewPairView(jobDay, opts) {
    var o = opts || {};
    var uk = _cpKeyer(o.unitKey);
    var pk = _cpKeyer(o.personKey);
    var out = { active: false, byPerson: {}, paired: [] };
    if (!_cpIsObj(jobDay)) return out;
    var map = jobDay.crewAssetAssignments;
    if (!_cpIsObj(map)) return out;

    var people = {};
    _cpList(jobDay.drivers).concat(_cpList(jobDay.helpers)).forEach(function (r) {
      var k = pk(r);
      if (k) people[k] = true;
    });
    var units = {};
    CREW_PAIR_KINDS.forEach(function (kind) {
      _cpList(jobDay[kind[1]]).forEach(function (r) {
        var k = uk(r);
        if (k) units[k] = true;
      });
    });

    var paired = [];
    Object.keys(map).sort().forEach(function (rawPid) {
      var p = pk(rawPid);
      if (!p || !people[p]) return;
      var e = map[rawPid];
      if (!_cpIsObj(e)) return;
      var mine = out.byPerson[p] ? out.byPerson[p].slice() : [];
      CREW_PAIR_KINDS.forEach(function (kind) {
        _cpList(e[kind[0]]).forEach(function (r) {
          var k = uk(r);
          if (!k || !units[k]) return;
          if (mine.indexOf(k) < 0) mine.push(k);
          if (paired.indexOf(k) < 0) paired.push(k);
        });
      });
      if (mine.length) out.byPerson[p] = mine;
    });
    out.paired = paired;
    out.active = paired.length > 0;
    return out;
  }

  // Units paired to THIS person (any of their keys — id and/or name).
  function crewPairMine(view, viewerKeys) {
    var out = [];
    if (!view || !view.active || !_cpIsObj(view.byPerson)) return out;
    _cpList(viewerKeys).forEach(function (k) {
      (view.byPerson[k] || []).forEach(function (u) {
        if (out.indexOf(u) < 0) out.push(u);
      });
    });
    return out;
  }

  // Rule 5. rowKeys = the canonical keys of the rows the clock-in surface lists.
  // Returns { mode: 'none' | 'paired' | 'unpaired', checked: [rowKey] }.
  function crewPairPreselect(view, rowKeys, viewerKeys) {
    var rows = _cpList(rowKeys);
    if (!view || !view.active) return { mode: 'none', checked: rows };
    var mine = crewPairMine(view, viewerKeys);
    if (mine.length) {
      return { mode: 'paired', checked: rows.filter(function (r) { return mine.indexOf(r) >= 0; }) };
    }
    var paired = Array.isArray(view.paired) ? view.paired : [];
    return { mode: 'unpaired', checked: rows.filter(function (r) { return paired.indexOf(r) < 0; }) };
  }

  // Write-side cleanup: keep only people still on the day and units still on the
  // day IN THE SAME KIND. Raw ids (dispatch writes doc ids). Returns a fresh map,
  // or null when nothing survives (null = clear the field = today's behaviour).
  function crewPairPrune(map, day) {
    if (!_cpIsObj(map) || !_cpIsObj(day)) return null;
    var people = _cpList(day.drivers).concat(_cpList(day.helpers));
    var out = {};
    var any = false;
    Object.keys(map).sort().forEach(function (rawPid) {
      var p = _cpStr(rawPid);
      if (!p || people.indexOf(p) < 0) return;
      var e = map[rawPid];
      if (!_cpIsObj(e)) return;
      var entry = { truckIds: [], trailerIds: [], assetIds: [] };
      var has = false;
      CREW_PAIR_KINDS.forEach(function (kind) {
        var live = _cpList(day[kind[1]]);
        _cpList(e[kind[0]]).forEach(function (u) {
          if (live.indexOf(u) >= 0 && entry[kind[0]].indexOf(u) < 0) { entry[kind[0]].push(u); has = true; }
        });
      });
      // TASK-10193 S2 — the seat flags in a TEAM truck ride along, kept only for
      // a truck this entry still carries (a co-driver flag beats a rider flag).
      // Written only when non-empty, so a day saved without them prunes to the
      // exact same shape as before.
      var co = _cpList(e.coDriverTruckIds).filter(function (u) { return entry.truckIds.indexOf(u) >= 0; });
      var rider = _cpList(e.riderTruckIds).filter(function (u) { return entry.truckIds.indexOf(u) >= 0 && co.indexOf(u) < 0; });
      if (rider.length) entry.riderTruckIds = rider;
      if (co.length) entry.coDriverTruckIds = co;
      if (has) { out[p] = entry; any = true; }
    });
    return any ? out : null;
  }

  // Whether the dispatch "Who's in what" rows apply: at least one person and one
  // unit, and 2+ people OR 2+ trucks. 1 driver + 1 truck (or 1 person + any gear)
  // is the implicit pairing — no UI, nothing written.
  function crewPairApplies(day) {
    if (!_cpIsObj(day)) return false;
    var people = _cpList(day.drivers).concat(_cpList(day.helpers));
    var nPeople = _cpList(people).length;
    var trucks = _cpList(day.trucks).length;
    var units = trucks + _cpList(day.trailers).length + _cpList(day.assets).length;
    return nPeople >= 1 && units >= 1 && (nPeople >= 2 || trucks >= 2);
  }

  // -----------------------------------------------------------------------------
  // SLICE 3 — SENIORITY: "first on, last off" (Wolverine, Steffani 10/12).
  // -----------------------------------------------------------------------------
  // Two pieces of data, both optional, both display-only (nothing enforces them):
  //
  //   settings.crewSeniority = [personId, ...]   company-wide, most senior FIRST.
  //       Set by dispatch (Dispatch Settings). Absent / [] = no seniority: every
  //       ordering below falls back to the order it was given (today's behaviour).
  //   jobDay.crewOrder = [personId, ...]          THIS day's "first on" order.
  //       Written by the assign save: people already in it keep their place, a
  //       newcomer goes on the END (by seniority among newcomers). So the first
  //       person put on a job stays first, whoever came last is "comes off next".
  //
  // Read-time filter, same as the pairing: a stored id that is no longer on the
  // day is ignored; a person on the day with no stored place is appended by
  // seniority. Neither list is ever a reason to block a save or a clock-in.

  var CREW_SENIORITY_MAX = 500; // mirrored by the firestore.rules shape cap

  // settings.crewSeniority, cleaned: strings, deduped, capped.
  function crewSeniorityList(list) {
    return _cpList(list).slice(0, CREW_SENIORITY_MAX);
  }

  // Stable order by company seniority. Ranked people first (by rank); people not
  // on the seniority list keep their incoming order AFTER them (a new hire is
  // the least senior until dispatch ranks them). No seniority → input order.
  function crewSenioritySort(keys, seniority, personKey) {
    var pk = _cpKeyer(personKey);
    var rank = {};
    crewSeniorityList(seniority).forEach(function (id, i) {
      var k = pk(id);
      if (k && rank[k] === undefined) rank[k] = i;
    });
    var items = _cpList(keys).map(function (k, i) {
      var r = rank[pk(k)];
      return { k: k, i: i, r: r === undefined ? -1 : r };
    });
    items.sort(function (a, b) {
      if (a.r >= 0 && b.r >= 0) return (a.r - b.r) || (a.i - b.i);
      if (a.r >= 0) return -1;
      if (b.r >= 0) return 1;
      return a.i - b.i;
    });
    return items.map(function (x) { return x.k; });
  }

  // The day's crew (drivers then helpers) in "first on" order, after the filter.
  // Returns { order: [personKey], stored, ranked } — `stored` = the day carries a
  // crewOrder that placed someone, `ranked` = the company has a seniority list.
  // Neither → `order` is simply drivers-then-helpers as stored (today's order).
  function crewOrderView(jobDay, seniority, opts) {
    var o = opts || {};
    var pk = _cpKeyer(o.personKey);
    var out = { order: [], stored: false, ranked: crewSeniorityList(seniority).length > 0 };
    if (!_cpIsObj(jobDay)) return out;
    var live = [];
    _cpList(jobDay.drivers).concat(_cpList(jobDay.helpers)).forEach(function (r) {
      var k = pk(r);
      if (k && live.indexOf(k) < 0) live.push(k);
    });
    var order = [];
    _cpList(jobDay.crewOrder).forEach(function (r) {
      var k = pk(r);
      if (k && live.indexOf(k) >= 0 && order.indexOf(k) < 0) order.push(k);
    });
    out.stored = order.length > 0;
    var rest = live.filter(function (k) { return order.indexOf(k) < 0; });
    out.order = order.concat(crewSenioritySort(rest, seniority, o.personKey));
    return out;
  }

  // Write side: the crewOrder to store for a day whose crew is now `nextPeople`
  // (raw ids, drivers then helpers). Whoever is already in `prevOrder` keeps that
  // place; newcomers are appended by seniority, then incoming order. [] when the
  // day has nobody. Pure — the caller decides whether to write it.
  function crewOrderNext(prevOrder, nextPeople, seniority) {
    var next = _cpList(nextPeople);
    var out = [];
    _cpList(prevOrder).forEach(function (p) {
      if (next.indexOf(p) >= 0 && out.indexOf(p) < 0) out.push(p);
    });
    var add = next.filter(function (p) { return out.indexOf(p) < 0; });
    return out.concat(crewSenioritySort(add, seniority));
  }

  // Carry / Edit Job: keep only people still on the day. null = nothing to carry.
  function crewOrderPrune(order, day) {
    if (!_cpIsObj(day)) return null;
    var live = _cpList(day.drivers).concat(_cpList(day.helpers));
    var out = _cpList(order).filter(function (p) { return live.indexOf(p) >= 0; });
    return out.length ? out : null;
  }

  // TASK-9797 S2 — "H2-Night" for the driver card / clock-in; '' while jobSlots is off.
  function crewSlotText(day, id, st) {
    var e = _cpIsObj(day) && _cpIsObj(day.unitSlots) ? day.unitSlots[_cpStr(id)] : 0;
    var l = _cpIsObj(st) && _cpIsObj(st.jobSlots) && st.jobSlots.enabled === true && _cpIsObj(e) ? _cpStr(e.label).replace(/[^A-Za-z0-9 #\/._-]/g, '').slice(0, 16) : '';
    var s = l && _cpStr(e.shift).toLowerCase();
    return l + (s === 'night' ? '-Night' : s === 'day' ? '-Day' : '');
  }

  window.CrewPairing = Object.freeze({
    view: crewPairView,
    mine: crewPairMine,
    preselect: crewPairPreselect,
    prune: crewPairPrune,
    applies: crewPairApplies,
    // TASK-9763 S3 — seniority: "first on, last off"
    seniority: crewSeniorityList,
    senioritySort: crewSenioritySort,
    orderView: crewOrderView,
    orderNext: crewOrderNext,
    orderPrune: crewOrderPrune,
    // TASK-9797 item 1 S2 — "your slot H2-Night" (driver card, clock-in)
    slot: crewSlotText
  });
})();
